<div>
	<div [ngClass]="sizeInternal" #divWidth>
		<div class="mat-elevation-z4"><ng-content></ng-content></div>
	</div>
</div>
